/**
 * Canonical API base URL for the Command Centre.
 *
 * Why this exists (Fuad 2026-06-12): a handful of legacy pages
 * hardcoded `http://localhost:8000/...` in their fetch calls, which
 * breaks in Docker (different container, no `localhost`). New code
 * should use the axios instances in `src/lib/api.ts` (relative paths
 * + Vite proxy in dev / reverse proxy in prod). When that's not
 * possible (legacy fetch / XHR), use this constant.
 *
 * Resolution order:
 *   1. VITE_API_BASE_URL set at build / runtime (e.g. Docker env)
 *   2. Empty string → relative URLs, picked up by the dev Vite proxy
 *      or whatever reverse proxy is in front of the CC in prod
 *
 * Same shape playbook-web already uses (src/lib/api.ts:72) — keeps
 * the deployment story aligned across the stack.
 */
export const API_BASE_URL: string =
  (import.meta as any).env?.VITE_API_BASE_URL ?? '';
